import { useEffect, useState } from 'react';
import apis from '../apis';

/**
 * Fetches APCS 2026 event data (ticket tiers, add-ons, sessions) from the backend.
 * Returns { event, loading, error }
 * event shape: { id, title, ticketTiers, addOns, sessions }
 */
const useTicketEventData = () => {
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await apis.publicTicket.getEventData();
                if (response?.error) throw new Error('Failed to load event data.');
                setEvent(response.data);
            } catch (err) {
                console.error('useTicketEventData error:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return { event, loading, error };
};

export default useTicketEventData;
